import { getBrowserType, getMobileOS } from '@/utils/common-util';
import { allowBrowserList, BROWSER_TYPE, MOBILE_OS_TYPE, notAllowInappList, enableInAppContentList } from '@/types';
import copy from 'copy-to-clipboard';

/**
 * 허용 되지 않은 콘텐츠 인앱 콘텐츠 커버 on
 * @param key
 * @returns
 */
export const inappCoverEnable = (key: string) => {
  return enableInAppContentList.indexOf(key) < 0;
};

/**
 * 허용 되지 않은 인앱 브라우저 타입 조회
 * @returns
 */
export const notAllowInapp = () => {
  const curBrowserType = getBrowserType();
  return !curBrowserType || (curBrowserType && (notAllowInappList.includes(curBrowserType) || !allowBrowserList.includes(curBrowserType)));
};

/**
 * 카카오 인앱 브라우저 외부연결
 * @param msg
 */
export const openKakaoExternal = (msg: string) => {
  const ua = navigator.userAgent;
  const target_url = window.location.href;
  try {
    location.href = 'kakaotalk://web/openExternal?url=' + encodeURIComponent(target_url);
    setTimeout(() => {
      location.href = /ipad|iphone|ipod/.test(ua) ? 'kakaoweb://closeBrowser' : 'kakaotalk://inappbrowser/close';
    });
  } catch (e) {
    console.error(e);
    copy(window.location.href);
    window.alert(msg);
  }
};

/**
 * 안드로이드 외부연결
 * @param msg
 */
export const openAndroidExternal = (msg: string) => {
  const target_url = window.location.href;
  try {
    window.location.href = 'intent://' + target_url.replace(/https?:\/\//i, '') + '#Intent;scheme=https;package=com.android.chrome;end';
  } catch (e) {
    console.error(e);
    copy(window.location.href);
    window.alert(msg);
  }
};

/**
 * 안드로이드 외 외부연결
 * @param msg
 * @param move
 */
export const openExternal = (msg: string, move: boolean) => {
  copy(window.location.href);
  window.alert(msg);
  if (move) window.location.href = 'x-web-search://?';
};
